'use strict';

var $ = require('jquery');

function init() {
	var $persistFormField = $("input[name='persistForm.name']");
	if ( $persistFormField.length === 0 ) {
		return;
	}
	
	var baseHref = $('base').attr('href');
	
	var ajaxPersistForm = function(action, $form) {
		var data = "action="+action+"&" + $form.serialize();
		
		$.ajax({
			type: "post",
			url: baseHref + "/form-data",
			data: data,
			dataType: "json"
		})
		.done(function(data, textStatus, jqXHR) {
			if ( typeof(data.data) != "undefined" ) {
				var formData = data.data;
				for (var prop in formData) {
					var value = formData[prop];

					//if ( typeof(console) != "undefined" ) {
					//	console.log(prop + " => " + value);
					//}
					
					var fields = $("[name=\"" + prop + "\"]", $form);
					fields.each(function() {
						var field = $(this);
						if (typeof (field) !== "undefined") {
							if (typeof (field.prop("tagName")) !== "undefined") {
								var tagName = field.prop("tagName").toLowerCase();
								if (tagName === "input") {
									var type = field.prop("type");
									if (type === "radio" || type === "checkbox") {
										field.prop('checked', false);
										var $filteredFields = field.filter('[value="' + value + '"]');
										if ($filteredFields.length !== 0) {
											$filteredFields.prop('checked', true);
										} else {
											for (var i = 0; i < value.length; i++) {
												field.filter('[value="' + value[i] + '"]').prop('checked', true);
											}
										}
									} else {
										field.val(value);
									}
								} else {
									// textarea, select
									field.val(value);
								}
							}
						}
					});
				}
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			if ( typeof(console) != "undefined" ) {
				console.log("Fail: " + textStatus + " -- " + errorThrown);
			}
		})
		;
	}

	$persistFormField.each(function(i){
		var $this = $(this);
		var name = $this.val();
		
		var $form = $this.closest('form');
		
		ajaxPersistForm("load", $form);
		
		// Auto save on change in field value (This is debounced)
		var saveTimeout;
		var saveFunction = function() {
			ajaxPersistForm("save", $form);
		};
		$form.find("input, select, textarea, select").change(function() {
			if ( typeof(saveTimeout) != "undefined" ) {
				clearTimeout(saveTimeout);
			}
			saveTimeout = setTimeout(saveFunction, 1500);
		});
	});

}
module.exports = {
	init : init
};
